module.exports = "/_next/static/images/hd-532c3679b269634dd63c30ca7b5de094.png";